import { render, staticRenderFns } from "./myShareGoods.vue?vue&type=template&id=781a9e59&scoped=true&"
import script from "./myShareGoods.vue?vue&type=script&lang=js&"
export * from "./myShareGoods.vue?vue&type=script&lang=js&"
import style0 from "./myShareGoods.vue?vue&type=style&index=0&id=781a9e59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781a9e59",
  null
  
)

export default component.exports